import React from "react"
import PropTypes from "prop-types"

import IconWithRollover from "./IconWithRollover"

const ReactionsIcon = ({onClick}) => {
  return (
    <IconWithRollover
      iconMouseOver="emojiActive"
      iconMouseOut="addEmoji"
      onClick={onClick} />
  )
}

ReactionsIcon.propTypes = {
  onClick: PropTypes.func.isRequired
}

export default ReactionsIcon
